module.exports = __webpack_public_path__ + "img/windows.c0cc773b.svg";